import { render, staticRenderFns } from "./ComplaintCreate.vue?vue&type=template&id=1f01d482&"
import script from "./ComplaintCreate.vue?vue&type=script&lang=js&"
export * from "./ComplaintCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports